<template>
    <section class="location-settings">
        <div class="rounded shadow-lg modal-content-container">
            <p class="mx-3 pt-2 mb-1 fw-bold">Settings</p>
            <hr />
            <div class="form-group form-check custom-checkbox m-3">
                <input type="checkbox" id="automatic-update" class="form-check-input" v-model="automaticUpdate" />
                <label class="form-check-label" for="automatic-update"> Update Location automatically </label>
            </div>
            <hr />
            <div class="form-group zip-input-group">
                <label for="patient-first-name" class="mx-3 mt-3 mb-1 fw-bold">
                    Location <span class="text-danger">*</span>
                </label>
                <hr />
                <div
                    :class="`px-3 py-2 d-flex justify-content-between ${automaticUpdate ? 'disable' : ''}`"
                    :disable="automaticUpdate"
                    v-if="showLocation"
                >
                    <span> {{ city }}, {{ state }} </span>
                    <i class="fas fa-edit" @click="showEditZipCode()"></i>
                </div>
                <div v-if="showEditZipCodeInput">
                    <input
                        :class="`form-control m-3 mb-0 w-75 ${zipError ? 'border border-danger' : ''}`"
                        v-model="zip"
                        placeholder="Zip Code (Ex: 12345)"
                    />
                    <i v-if="zip" class="fas fa-times clear-search" @click="clearZip()"></i>
                    <div v-if="zipError" class="invalid-feedback d-block mx-3">Enter a Valid Zip Code</div>
                    <div class="mt-2 mx-3 d-flex justify-content-end">
                        <button @click="zipNotEntered()" type="button" class="btn btn-xs me-2 btn-outline-primary">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="form-group mt-3">
                <p class="mx-3 mb-1 fw-bold">Temperature <span class="text-danger">*</span></p>
                <hr />
                <div class="btn-group btn-group-toggle m-3" data-bs-toggle="buttons">
                    <label
                        :class="`btn btn-outline-primary font-size-xs ${isCurrent ? 'active' : ''}`"
                        @click="setIsCurrent(true)"
                    >
                        <input type="radio" hidden name="is-current" autocomplete="off" /> Celsius
                    </label>
                    <label
                        :class="`btn btn-outline-primary font-size-xs ${isCurrent ? '' : 'active'}`"
                        @click="setIsCurrent(false)"
                    >
                        <input type="radio" hidden name="is-current" autocomplete="off" /> Fahrenheit
                    </label>
                </div>
            </div>
            <hr />
            <div class="mt-1 d-flex p-3 justify-content-end">
                <button @click="cancel()" type="button" class="btn btn-xs me-2 btn-outline-primary">Cancel</button>
                <button @click="save()" type="button" class="btn btn-xs btn-primary">Save</button>
            </div>
        </div>
    </section>
</template>

<style src="./LocationSettings.scss"></style>
<script lang="ts" src="./LocationSettings.ts"></script>
